var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirlceCheckBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4238 5.66095C52.9924 5.66095 66.4238 19.0924 66.4238 35.6609C66.4238 52.2295 52.9924 65.6609 36.4238 65.6609C19.8553 65.6609 6.42383 52.2295 6.42383 35.6609C6.42383 19.0924 19.8553 5.66095 36.4238 5.66095ZM36.4238 9.41095C21.9264 9.41095 10.1738 21.1635 10.1738 35.6609C10.1738 50.1584 21.9264 61.9109 36.4238 61.9109C50.9213 61.9109 62.6738 50.1584 62.6738 35.6609C62.6738 21.1635 50.9213 9.41095 36.4238 9.41095ZM49.3747 26.0851C50.1069 26.8174 50.1069 28.0045 49.3747 28.7368L32.8747 45.2368C32.1424 45.969 30.9552 45.969 30.223 45.2368L23.473 38.4868C22.7408 37.7545 22.7408 36.5674 23.473 35.8351C24.2052 35.1029 25.3924 35.1029 26.1247 35.8351L31.5488 41.2593L46.723 26.0851C47.4552 25.3529 48.6424 25.3529 49.3747 26.0851Z",
    fill: "#0065F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirlceCheckBlue);
export default __webpack_public_path__ + "static/media/cirlce-check-blue.6b49a549b60500453cede57b36d9d7c6.svg";
export { ForwardRef as ReactComponent };